import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import * as classes from "./FigureAlt.module.scss";

export default function FigureAlt({className, ...props}) {
    return (
        <figure
            className={classNames(classes.container, className)}
            {...props} />
    );
}

FigureAlt.propTypes = {
    className: PropTypes.string
};
